import { MedicalItemsTab } from "@/Common/Models/Patient/PatientEnums";
import { PatientMedicalSummaryHelper } from "@/Patient/Helpers/PatientMedicalSummaryHelper";
import { MedicalItemSubtypeEnum } from "@/Patient/Models/MedicalSummary/Enum/MedicalItemSubTypeEnum";
import { MedicalItem } from "@/Patient/Models/MedicalSummary/MedicalItem";
import { IPatientMedicalNoteModel } from "@/Patient/Models/UI/MedicalNote/IPatientMedicalNoteModel";
import { IPatientMedicalSummaryModel } from "@/Patient/Models/UI/MedicalSummary/IPatientMedicalSummaryModel";
import { ProblemItems } from "./ProblemItems";

interface IProblemsSummaryProps {
    noteModel: IPatientMedicalNoteModel;
    medicalSummaryModel: IPatientMedicalSummaryModel;
    dateOfBirth: Date;
    isSignedOff: boolean;
    isEditMode: boolean;
    onMedicalItemClick: (item: MedicalItem, view: MedicalItemsTab) => void;
    addMedicalHistoryItem: () => void;
}

function ProblemsSummary(props: IProblemsSummaryProps): JSX.Element {
    const activeProblems = PatientMedicalSummaryHelper.GetMedicalProblemHistoryForNote(
        props.medicalSummaryModel,
        props.noteModel,
        MedicalItemSubtypeEnum.ProblemAndCondition_Ongoing,
        props.dateOfBirth
    );

    const historyProblems = PatientMedicalSummaryHelper.GetMedicalProblemHistoryForNote(
        props.medicalSummaryModel,
        props.noteModel,
        MedicalItemSubtypeEnum.ProblemAndCondition_Past,
        props.dateOfBirth
    );

    const historySurgery = PatientMedicalSummaryHelper.GetMedicalProblemHistoryForNote(
        props.medicalSummaryModel,
        props.noteModel,
        MedicalItemSubtypeEnum.ProblemAndCondition_SurgicalPast,
        props.dateOfBirth
    );

    const historyPsy = PatientMedicalSummaryHelper.GetMedicalProblemHistoryForNote(
        props.medicalSummaryModel,
        props.noteModel,
        MedicalItemSubtypeEnum.ProblemAndCondition_Psychiatric,
        props.dateOfBirth
    );

    const historyGyn = PatientMedicalSummaryHelper.GetMedicalProblemHistoryForNote(
        props.medicalSummaryModel,
        props.noteModel,
        MedicalItemSubtypeEnum.ProblemAndCondition_Gynecology,
        props.dateOfBirth
    );

    const noProblems: boolean = (isArrayNullOrUndefinedOrEmpty(activeProblems)
        && isArrayNullOrUndefinedOrEmpty(historyProblems)
        && isArrayNullOrUndefinedOrEmpty(historySurgery)
        && isArrayNullOrUndefinedOrEmpty(historyGyn)
        && isArrayNullOrUndefinedOrEmpty(historyPsy)
    );

    return (
        <table>
            <tbody>
                {!isArrayNullOrUndefinedOrEmpty(activeProblems) && (
                    <ProblemItems
                        title={cacheStore.GetString("ProblemesActifsLabel")}
                        problems={activeProblems}
                        onMedicalItemClick={props.onMedicalItemClick}
                    />
                )}
                {!isArrayNullOrUndefinedOrEmpty(historyProblems) && (
                    <ProblemItems
                        title={cacheStore.GetString("AntecedentsMedicauxLabel")}
                        problems={historyProblems}
                        onMedicalItemClick={props.onMedicalItemClick}
                    />
                )}
                {!isArrayNullOrUndefinedOrEmpty(historySurgery) && (
                    <ProblemItems
                        title={cacheStore.GetString("AntecedentsChirurgicauxLabel")}
                        problems={historySurgery}
                        onMedicalItemClick={props.onMedicalItemClick}
                    />
                )}
                {!isArrayNullOrUndefinedOrEmpty(historyPsy) && (
                    <ProblemItems
                        title={cacheStore.GetString("AntecedentsPsychiatriquesLabel")}
                        problems={historyPsy}
                        onMedicalItemClick={props.onMedicalItemClick}
                    />
                )}
                {!isArrayNullOrUndefinedOrEmpty(historyGyn) && (
                    <ProblemItems
                        title={cacheStore.GetString("AntecedentsObstetriquesLabel")}
                        problems={historyGyn}
                        onMedicalItemClick={props.onMedicalItemClick}
                    />
                )}
                <>
                    {noProblems && (
                        <tr>
                            <td className="c1">
                                <strong>{cacheStore.GetString("MedicalHistoryLabel")}</strong>
                            </td>
                            <td className="c2">
                                <div className="tb-row tb">
                                    <div className="add-btn-column"> </div>
                                </div>
                            </td>
                        </tr>
                    )}
                    {!props.isSignedOff && (
                        <tr>
                            <td className="c1" />
                            <td className="c2">
                                <div className="tb-row">
                                    {props.isEditMode && (
                                        <div>
                                            <a
                                                data-cy="medicalNote-add-medicalHistory"
                                                onClick={() => {
                                                    patientStore.IsMedicalItemFromOutsideNote = false;
                                                    props.addMedicalHistoryItem();
                                                }}
                                            >{"[+] "}
                                            </a>
                                            <strong>{cacheStore.GetString("MedicalHistoryLabel")}</strong>
                                        </div>
                                    )}
                                </div>
                            </td>
                            <td className="c3" />
                        </tr>
                    )}
                </>
            </tbody>
        </table>
    );
}

export { ProblemsSummary };
